<template>
	<div class="deliverable-listing social-media grouped-by-date pt-0" :class="{hasFilter: (filterQuery.status.length || filterQuery.coordinator.length || filterQuery.tag.length || filterQuery.outlet.length)}" tabindex="-1">
		<div>
			<div class="deliverable-header ">
				<HeaderIcon
					:totalDeliverableCount="this.allDeliverablesPaginationData.total ? this.allDeliverablesPaginationData.total : 0"
					:totalOutletCount="this.outletCount ? this.outletCount : 0"
					:myWeek="myWeek"
					:title="getGroupHeading"
					:groupTypeTitle="getGroupType"
					:campaignId="socialCampaignId"
					:seriesId="socialSeriesId"
					:masterDeliverableId="masterDeliverableId"
					:parentDeliverableId="parentDeliverableId"
					@toggleExpanded="toggleExpanded"
					:namespace="namespace"
				/>
			</div>


			<div class="deliverable-block">
				<div class="delv-block-resp">
					<div class="d-flex flex-row dbox-wrapper">
						<div class="dbox-left-side dleft-inner-wrap">

							<b-collapse :visible="expanded" :id="'task-listing-collapse-'+Math.random()">
								<div id="global-spinner-above-list" v-show="dataLoading"
								style="left:50%; border:none; background:transparent;z-index:9000;">
									<b-spinner label="Loading"></b-spinner>
								</div>
								<div class="dtable">
									<div class="dtr top-row social list-labels">
										<div class="dtd info-heading titles">
											<span>Post Name</span>
										</div>
										<div class="dtd info-heading message-counter" >
										</div>
										<div class="dtd info-heading users" >
											<span>People</span>
										</div>
										<div class="dtd info-heading publish-date" >
											<span>Posting Date</span>
										</div>
										<div class="dtd info-heading caption" v-for="lang in listedLanguages">
											<span>Post Copy</span>
										</div>
										<div class="dtd info-heading thumbnail">
											<span>Image, Alt Tag</span>
										</div>
										<div class="dtd info-heading social-network" >
											<span>Platforms</span>
										</div>
										<div class="dtd info-heading languages" >
											<span>EN/FR</span>
										</div>

										<div class="dtd info-heading publish-status">
											<span>Status</span>
										</div>
									</div>
									<div class="dtr listing-row"
										:class="getRowClass(deliverable, index)"
										v-for="(deliverable, index) in allDeliverables"
										:key="'deliverable'+index"
										ref="listing-row"
										:data-deliverable-id="deliverable.id">
										<div  class="dtd infos calendar-type" v-if="false">
											<div v-b-tooltip.hover title="Delete" v-if="userCanEditDeliverable()" tabindex="0"  @click.stop="deleteDeliverableClick(deliverable)" :class="`delete-bar ${deliverable.id == stripRemoveDeliverableId ? 'hovered' : ''}`" v-click-outside="deleteDeliverableClickOutside(deliverable.id)" :style="getDeliverableSideBarStyle(deliverable)">
												<span><i class="fas fa-trash"></i></span>
											</div>
										</div>

										<div class="dtd titles breakpoint__fix" :style="infoColStyle(deliverable)" tabindex="-1">
											<ListDeliverableStatusBar  :deliverable="deliverable" :namespace="namespace" @deleteDeliverable="deleteDeliverableClick" @duplicateDeliverable="duplicateDeliverable" tabindex="0" />

											<div tabindex="0"  v-b-tooltip.hover title="Delete" v-if="userCanEditDeliverable() && 1 == 2"  @click.stop="deleteDeliverableClick(deliverable)" :class="`delete-bar ${deliverable.id == stripRemoveDeliverableId ? 'hovered' : ''}`" v-click-outside="deleteDeliverableClickOutside(deliverable.id)" :style="getDeliverableSideBarStyle(deliverable)">
												<span><i class="fas fa-trash"></i></span>
											</div>
											<div
												:class="`deliverable-title edit-d-title-stacked delete-bar-left cursor-pointer`"
												@click="clickDeliverableTitle(deliverable, $event)"
												@keyup.enter="clickDeliverableTitle(deliverable, $event)"
												tabindex="0"
											>
												<span class="title-text">
													<span class="link-icon" v-if="showManuallyUpdatedIcon(deliverable)">
														<i class="fas fa-unlink"></i>
													</span>
													{{ deliverable.title }}&nbsp;
												</span>
											</div>


											<div class="mobile-task-expand-button-area">
												<div class="mobile-task-exp-btn">
													<CollapseTaskBtn :deliverable="deliverable" :index="index" :expandAll="expanded" :namespace="namespace"/>
												</div>
											</div>
										</div>

										<!-- Hard code these like projects, the modal is hard coded anyway -->
										<div
											v-if="!isMobile()"
											v-for="(field, index) in _.filter(deliverable.customFields, {field_key: 'user'})" :key="''+deliverable.id+field.field_id"
											class="dtd infos cursor-pointer" tabindex="0" @click="clickTaskUsers(deliverable)" @keyup.enter.stop="clickTaskUsers(deliverable, $event)">
											<SocialCustomFields :customField="field" :deliverable="deliverable" :namespace="namespace"/>
										</div>
										<div tabindex="0" class="dtd infos message-counter cursor-pointer" @click="clickDeliverableCommentsCell(deliverable, $event)" @keyup.enter.stop="clickDeliverableComments(deliverable, $event)">
											<SocialPostMessageCounter :deliverable="deliverable" @clickMessageCounter="clickDeliverableComments(deliverable)" :namespace="namespace"/>
										</div>
										<div tabindex="0" class="dtd infos users cursor-pointer"  @click="clickTaskUsers(deliverable, $event)" @keyup.enter.stop="clickTaskUsers(deliverable, $event)">
											<span></span>
											<DeliverableListUsers :deliverable="deliverable" />
										</div>

										<div  class="dtd infos publish-date" v-if="deliverable.is_master == 0 && 1 == 2">
											<span class="link-icon" v-if="showManuallyUpdatedIcon(deliverable)">
												<i class="fas fa-unlink"></i>
											</span>
										<DeliverablePublishDatePicker :deliverable="deliverable" :namespace="namespace" />
										</div>



										<div  class="dtd infos publish-date" v-if="deliverable.is_master == 0">
											<span v-b-tooltip.hover :title="getPublishStatusText(deliverable.publish_status)">
												<span
													:class="getPublishStatusClass(deliverable.publish_status)"
												  :style="getPublishDateStyle(deliverable.publish_date)"
												  v-if="deliverable.publish_date"
												v-html="formatDate(deliverable.publish_date)"></span>
												<span class="not-set exclude-outside-click" v-else>No Date</span>
											</span>
										</div>

										<div  class="dtd infos publish-date" v-if="deliverable.is_master == 1">
											<span v-html="getNoDateText(deliverable.social_series_deliverables)" v-if="getNoDateText(deliverable.social_series_deliverables)">
											</span>
											<span v-for="(ssd,ssd_idx) in deliverable.social_series_deliverables.filter(v => { return v.publish_date != null })">
												<span  v-b-tooltip.hover :title="getPublishStatusText(ssd.publish_status)"
												  	:class="getPublishStatusClass(ssd.publish_status)"
												    :style="getPublishDateStyle(ssd.publish_date)"

												  v-if="ssd.publish_date"
												v-html="formatDate(ssd.publish_date)"></span>
											</span>
										</div>


										<div tabindex="0" class="dtd infos caption cursor-pointer" @click="clickPostCopy(deliverable, $event)" @keyup.enter.stop="clickPostCopy(deliverable, $event)">
											<div class="char-count" v-html="getCaption(deliverable, true)"></div>
											<div class="caption-text" v-html="getCaption(deliverable)"></div>
										</div>
										<div tabindex="0" class="dtd infos thumbnail cursor-pointer" v-html="getSocialPostThumbnailAndAltText(deliverable)" @click="clickThumbnail(deliverable, $event)" @keyup.enter.stop="clickThumbnail(deliverable, $event)">
										</div>



										<div tabindex="0" class="dtd infos social-networks cursor-pointer" @click="clickPlatforms(deliverable, $event)" @keyup.enter.stop="clickPlatforms(deliverable, $event)">
											<span class="info-bubbles social-networks">
												<span v-for="(net,net_idx) in deliverable.social_networks" :class="'social-networks initials badge badge-primary '+getSocialNetworkColorClass(net, deliverable)"
												:title="getSocialNetworkTypeById(net)" >
													<i :class="'fab fa-'+getSocialNetworkClassById(net)+' platform-indicator'"></i>
												</span>
											</span>
										</div>
										<div tabindex="0" class="dtd infos languages cursor-pointer" @click="clickLanguages(deliverable, $event)" @keyup.enter.stop="clickLanguages(deliverable, $event)" >
											<span class="info-bubbles languages">
												<span
													v-for="(lang,lang_idx) in deliverable.languages"
													v-b-tooltip.hover.html
													:title="getLangCodeById(lang)"
													class="languages initials badge badge-primary"
													:class="getLangColorClass(lang,deliverable)"
												>
													<span class="exclude-outside-click">{{getLangCodeById(lang)}}</span>
												</span>
											</span>
										</div>







										<div tabindex="0" class="dtd infos publish-status">
											<!--<PublishStatusListLabel :deliverable="deliverable" @clickStatusLabel="clickDeliverableStatus(deliverable)" />-->
											<SocialStatusLabel :deliverable="deliverable" :isList="true" :namespace="namespace"/>
										</div>
									</div>
								</div>

								<div class="dtable bottom-row social">
									<div class="dtr">
										<div tabindex="0" class="dtd filtered-text d-flex">
											<pagination :data="allDeliverablesPaginationData" @pagination-change-page="onChangePage" :show-disabled="true"  :limit="5" ></pagination>
											<button v-if="1 == 2 && (getSystemSetting('social_media___show_new_post_button') || showNewPostButton )" type="button" class="btn btn-theme header-filter-btns social-group-new-post-btn btn-pagination" @click="newPost"><span  v-html="getNewPostButtonText()"></span><i class="fas text-primary float-right fa-plus fa-fw"></i></button>
										</div>
									</div>
								</div>
							</b-collapse>


						</div>
					</div>

				</div>
			</div>

		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import EditSocialModal from "./EditSocialModal";
import TaskFields from "./TaskFields";
import TaskFieldLabels from "./TaskFieldLabels";
import CreateContactModal from "./CreateContactModal";
import UpdateContactModal from "./EditContactModal";
import ViewTitleModal from "../common/ViewTitleModal";
import UpdateSpokespersonModal from "./EditSpokespersonModal";
import CreateSpokespersonModal from "./CreateSpokespersonModal";
import vueStarRate from "vue-js-star-rating";
import DeliverablePublishDatePicker from "../common/DeliverablePublishDatePicker";
import DuplicateMediaCallBtn from "../common/DuplicateMediaCallBtn";
import DeliverableStatusOverview from './DeliverableStatusOverview';
// import DeliverablePriorityBadge from "../common/DeliverablePriorityBadge";

import UpdateWhoModal from "./EditWhoModal";
import CreateWhoModal from "./CreateWhoModal";

import ListDeliverableStatusBar from "./ListDeliverableStatusBar.vue";

import DeliverableListTags from "./DeliverableListTags";
import DeliverableProjects from "./DeliverableProjects";
import DeliverableDepartments from "./DeliverableDepartments";
import DeliverableListContacts from "./DeliverableListContacts";
import DeliverableListCoordinators from "./DeliverableListCoordinators";
import TaskCompletionGraph from "./TaskCompletionGraph";
import CollapseTaskBtn from "./CollapseTaskBtn";
import DeliverableTypeIcon from './DeliverableTypeIcon';
import DeliverableDatesRibbon from "./DeliverableDatesRibbon";
import SocialCustomFields from '../common/SocialCustomField';
import HeaderIcon from './HeaderIconSocialGrouped';
import toast from '../../toast';
import DeliverableListUsers from "./DeliverableListUsers";
import PublishStatusListLabel from "./PublishStatusListLabel";
import SocialStatusLabel from "./SocialStatusLabel.vue";
import SocialPostMessageCounter from "./SocialPostMessageCounter";
import Autolinker from 'autolinker';


export default {
	props: [
		"selectedDeliverable",
		"myWeek",
		"filterQuery",
		"expandAll",
		"calendarOnly",
		"socialSeriesId",
		"socialCampaignId",
		"hasSocialSeries",
		"hasSocialCampaign",
		"socialSeriesName",
		"socialCampaignName",
		"masterDeliverableId",
		"parentDeliverableId",
		"namespace",
		"showNewPostButton",
		"pageCount"
	],
	data() {
		return {
			lastFocusTarget:null,
			socialMediaFilterParams: {
				page:1,
				pageCount:null
			},
			activeView: -1,
			showUpdateView: false,
			viewBtnLabel: 'Views',
			currentViewData: {},
			currentFilterData: false,
			showUpdateViewText: false,
			showCreateNewView: false,
			viewId: '',
			viewModalShowCreateView: false,
			viewModalShowUpdateView: false,
			expanded:true,
			showNewViewTitleArea: false,
			showUpdateViewTitleArea: false,
			currentYear:null,
			currentMonth:null,
			currentDay:null,
			showRemoveDeliverableId: null,
			stripRemoveDeliverableId: null,
			captionMaxLength: 280,
		}
	},
	components: {
		ListDeliverableStatusBar,
		EditSocialModal,
		TaskFields,
		TaskFieldLabels,
		DeliverableListContacts,
		CreateContactModal,
		UpdateContactModal,
		UpdateSpokespersonModal,
		CreateSpokespersonModal,
		UpdateWhoModal,
		CreateWhoModal,
		DeliverableListTags,
		DeliverableListCoordinators,
		TaskCompletionGraph,
		CollapseTaskBtn,
		DuplicateMediaCallBtn,
		DeliverableDatesRibbon,
		DeliverableDepartments,
		ViewTitleModal,
		vueStarRate,
		DeliverableProjects,
		DeliverableTypeIcon,
		DeliverableStatusOverview,
		SocialCustomFields,
		DeliverablePublishDatePicker,
		HeaderIcon,
		DeliverableListUsers,
		PublishStatusListLabel,
		SocialStatusLabel,
		SocialPostMessageCounter,
	},
	computed: {
		...mapState({
    state (state) {
      return state[this.namespace]
    },
    showPostContentLangInListing(state, getters){
    	return getters[this.namespace + 'showPostContentLangInListing']
    },
    showPostContentNetworkInListing(state, getters){
    	return getters[this.namespace + 'showPostContentNetworkInListing']
    },
			getSocialNetworkClass(state, getters) {
				return getters['getSocialNetworkClass']
			},
		dataLoading(state, getters){
			return getters[this.namespace + 'dataLoading']
		},
		allDeliverables (state, getters) {
			return getters[this.namespace + 'allDeliverables']
		},
		allSocialCampaigns (state, getters) {
			return getters[this.namespace + 'allSocialCampaigns']
		},
		allSocialSeries (state, getters) {
			return getters[this.namespace + 'allSocialSeries']
		},
		allDeliverablesPaginationData (state, getters) {
			return getters[this.namespace + 'allDeliverablesPaginationData']
		},
		userDeliverablesPaginationData (state, getters) {
			return getters[this.namespace + 'userDeliverablesPaginationData']
		},
		allTags (state, getters) {
			return getters[this.namespace + 'allTags']
		},
		allContacts (state, getters) {
			return getters[this.namespace + 'allContacts']
		},
		deliverableDetail (state, getters) {
			return getters[this.namespace + 'deliverableDetail']
		},
		allDepartments (state, getters) {
			return getters[this.namespace + 'allDepartments']
		},
		allSubjects (state, getters) {
			return getters[this.namespace + 'allSubjects']
		},
		userDeliverables (state, getters) {
			return getters[this.namespace + 'userDeliverables']
		},
		unGroupedUserDeliverables (state, getters) {
			return getters[this.namespace + 'unGroupedUserDeliverables']
		},
		deliverableFilter (state, getters) {
			return getters[this.namespace + 'deliverableFilter']
		},
		myWeekDeliverableFilter (state, getters) {
			return getters[this.namespace + 'myWeekDeliverableFilter']
		},
		outletCount (state, getters) {
			return getters[this.namespace + 'outletCount']
		},
		userAbilities (state, getters) {
			return getters['userAbilities']
		},
		userViews (state, getters) {
			return getters[this.namespace + 'userViews']
		},
		deliverableTypes (state, getters) {
			return getters[this.namespace + 'deliverableTypes']
		},
		userManageProjects (state, getters) {
			return getters[this.namespace + 'userManageProjects']
		},
		deliverableCount (state, getters) {
			return getters[this.namespace + 'deliverableCount']
		},
		systemSettings (state, getters) {
			return getters['systemSettings']
		},
		getSocialMediaOnlyCalendar (state, getters) {
			return getters[this.namespace + 'getSocialMediaOnlyCalendar']
		},
		getSocialMediaWithSocialCampaignAndSeries (state, getters) {
			return getters[this.namespace + 'getSocialMediaWithSocialCampaignAndSeries']
		},
		getSocialMediaWithSocialSeries (state, getters) {
			return getters[this.namespace + 'getSocialMediaWithSocialSeries']
		},
		getSocialMediaWithSocialCampaign (state, getters) {
			return getters[this.namespace + 'getSocialMediaWithSocialCampaign']
		},
		getLangCodeById (state, getters) {
			return getters[this.namespace + 'getLangCodeById']
		},
		getSocialNetworkTypeById (state, getters) {
			return getters[this.namespace + 'getSocialNetworkTypeById']
		},
		getSocialNetworkClassById (state, getters) {
			return getters[this.namespace + 'getSocialNetworkClassById']
		},
		socialMediaFilter (state, getters) {
			return getters[this.namespace + 'socialMediaFilter']
		},
		getSystemSetting (state, getters) {
			return getters[this.namespace + 'getSystemSetting']
		},
		editSocialModal (state, getters) {
			return getters[this.namespace + 'editSocialModal']
		},
		addContactModal (state, getters) {
			return getters[this.namespace + 'addContactModal']
		},
		editContactModal (state, getters) {
			return getters[this.namespace + 'editContactModal']
		},
		editSpokespersonModal (state, getters) {
			return getters[this.namespace + 'editSpokespersonModal']
		},
		editWhoModal (state, getters) {
			return getters[this.namespace + 'editWhoModal']
		},
		getDeliverableTemplateSlug (state, getters) {
			return getters['getDeliverableTemplateSlug']
		},
		}),
		deliverableListIcon() {
			if(this.deliverableFilter.deliverableType && typeof(this.deliverableFilter.deliverableType[0]) == 'undefined') {
				if(typeof this.deliverableFilter.deliverableType.id != 'undefined' && this.deliverableFilter.deliverableType.id != 'all') {
					return this.deliverableFilter.deliverableType.id.replaceAll('_', '-');
				} else {
					return 'media-call';
				}
			} else {
				return 'media-call';
			}
		},
		getGroupHeading() {

			let introHeading = "";
			let byCreationDate = false;

			if (typeof this.socialMediaFilter.filterParentDeliverable != "undefined") {
					if (this.socialMediaFilter.filterParentDeliverable.length == 1) {
						introHeading = this.socialMediaFilter.filterParentDeliverable[0].project_title;
						if (introHeading != "") introHeading += " > ";
					}
			}

			if (typeof this.socialMediaFilter.multiSort != "undefined") {
				if (this.socialMediaFilter.multiSort[0] == "created_at:asc") {
						byCreationDate = true;
						// sorting by created_at instead of publish_date.
						if (this.socialMediaFilter.listByDateRange.startDate == null &&
							this.socialMediaFilter.listByDateRange.endDate == null) {
							return introHeading+"All By Created Date";
						}
				}
				if (this.socialMediaFilter.multiSort[0] == "title:asc") {
						byCreationDate = false;
						if (this.socialMediaFilter.listByDateRange.startDate == null &&
							this.socialMediaFilter.listByDateRange.endDate == null) {
							return introHeading+"All By Post Name";
						}
				}
			} else {
				if (this.socialMediaFilter.listByDateRange.startDate == null &&
					this.socialMediaFilter.listByDateRange.endDate == null) {
					return introHeading+"All By Posting Date";
				}
			}

			const listDateRange = this.socialMediaFilter.filterByPublishDate ? this.socialMediaFilter.datePublishRange : this.socialMediaFilter.listByDateRange;
			const listByDate = this.socialMediaFilter.filterByPublishDate || this.socialMediaFilter.listByDate;

			const startDate = this.$moment(listDateRange.startDate);
			const endDate = this.$moment(listDateRange.endDate);

			const calendarFormat = this.$moment().isSame(startDate, 'year') && this.$moment().isSame(endDate, 'year') ? 'MMMM DD' : 'MMMM DD, YYYY';
			const calendarFormatMonth = this.$moment().isSame(startDate, 'year') ? 'MMMM' : 'MMMM, YYYY';


			if (listDateRange && listByDate) {
				if (startDate.isSame(endDate, 'day')) {
					if (byCreationDate) {
						if (startDate.isSame(endDate)) {
								// exactly the same means the month view.
							return introHeading+`Created in ${startDate.format(calendarFormatMonth)}`;
						} else {
							return introHeading+`Created in ${startDate.format(calendarFormat)}`;
						}
					} else {
						return introHeading+`${startDate.format(calendarFormat)} Calendar`;
					}
				}

				const isStartEndSameMonth = startDate.isSame(endDate, 'month');
				if (isStartEndSameMonth) {
					const startOfMonth = this.$moment(startDate).startOf("month");
					const endOfMonth = this.$moment(endDate).endOf("month");
					if (startOfMonth.isSame(startDate, 'day') && endOfMonth.isSame(endDate, 'day')) {
						if (byCreationDate) {
							return introHeading+`Created in ${startOfMonth.format(calendarFormatMonth)}`;
						} else {
							return introHeading+`${startOfMonth.format(calendarFormatMonth)} Calendar`;
						}
					}
				}
				if (byCreationDate) {
					if (listDateRange.startDate != null && listDateRange.endDate != null) {
						return introHeading+`Created ${this.$moment(listDateRange.startDate).format(calendarFormat)} to ${this.$moment(listDateRange.endDate).format(calendarFormat)}`;
					} else {
						return introHeading+`All By Created Date`;
					}
				} else {
					if (listDateRange.startDate != null && listDateRange.endDate != null) {
						return introHeading+`${this.$moment(listDateRange.startDate).format(calendarFormat)} to ${this.$moment(listDateRange.endDate).format(calendarFormat)} Calendar`;
					} else {
						return introHeading+`All By Posting Date`;
					}
				}
			} else {
				if (byCreationDate) {
					return introHeading+`Created in ${this.$moment().format(calendarFormatMonth)}`;
				} else {
					return introHeading+`${this.$moment().format(calendarFormatMonth)} Calendar`;
				}
			}
		},
		getGroupType() {
			return "";
		},
		getSummaryFilterText() {
			var text = "";
			var count = this.allDeliverablesPaginationData.total;
			// text =  "Monthly Calendar ";
			var from = this.allDeliverablesPaginationData.from;
			var to = this.allDeliverablesPaginationData.to;

			return text + "<span>" + count + " " + this.getPostPlural(count) +"</span>";
		},



		getSummaryTotalText() {
			var text = "";
			var count = this.deliverablesArray.length;
			if (this.calendarOnly) {
				text =  "Monthly Calendar";
			}
			if (this.socialSeriesId != null && this.socialCampaignId != null && this.hasSocialCampaign && this.hasSocialSeries) {
				text =  "Series in Campaign";
			}
			if (this.socialSeriesId != null && !this.hasSocialCampaign && this.hasSocialSeries) {
				text =  "Series";
			}
			if (this.socialCampaignId != null && this.hasSocialCampaign && !this.hasSocialSeries) {
				text =  "Campaign";
			}
			return text + "<span>" + count + " " + this.getPostPlural(count) +"</span>";
		},


		deliverablesArray() {
			if(this.myWeek) {
				return this.userDeliverables
			} else {
				if (this.namespace == "") {
	        return this.allDeliverables.filter((el) => {
	            return el.is_master == 0;
	        })
	      } else {
	      	return this.allDeliverables;
	      }
			}
		},
		socialCampaignsArray() {
			if(this.myWeek) {
				return this.userSocialCampaigns
			} else {
				return this.allSocalCampaigns;
			}
		},
		socialSeriesArray() {
			if(this.myWeek) {
				return this.userSocialSeries
			} else {
				return this.allSocalSeries;
			}
		},
		_() {
			return _;
		},
		userViewsDeliverable() {
			return _.filter(this.userViews, {view_type: "deliverable"});
		},

		token(){
		  return this.$store.getters.authToken;
		},
		apiUrl() {
			return process.env.MIX_API_BASE_URL;
		},
		listedLanguages() {
			let langs = [];
			let that = this;
			if(this.systemSettings.languages){
				for(var j = 0; j < 2; j++){
					if (that.systemSettings.languages[j].lang_code == "en") {
						langs.push(that.systemSettings.languages[j]);
					}
				}
				// let's show the first language we got.
				if (langs.length == 0 && that.systemSettings.languages.length > 0) {
					langs.push(that.systemSettings.languages[0]);
				}
			}
			return langs;
		},
 	},
	methods: {
		...mapActions({
			fetchSocialMediaDeliverablesGrouped (dispatch, payload) {
				return dispatch(this.namespace + 'fetchSocialMediaDeliverablesGrouped', payload)
			},
			createTag (dispatch, payload) {
				return dispatch(this.namespace + 'createTag', payload)
			},
			fetchUsers (dispatch, payload) {
				return dispatch(this.namespace + 'fetchUsers', payload)
			},
			fetchSocialSeries (dispatch, payload) {
				return dispatch(this.namespace + 'fetchSocialSeries', payload)
			},
			fetchSocialCampaigns (dispatch, payload) {
				return dispatch(this.namespace + 'fetchSocialCampaigns', payload)
			},
			fetchActiveUsers (dispatch, payload) {
				return dispatch(this.namespace + 'fetchActiveUsers', payload)
			},
			fetchContacts (dispatch, payload) {
				return dispatch(this.namespace + 'fetchContacts', payload)
			},
			updateFieldValue (dispatch, payload) {
				return dispatch(this.namespace + 'updateFieldValue', payload)
			},
			fetchDepartments (dispatch, payload) {
				return dispatch(this.namespace + 'fetchDepartments', payload)
			},
			fetchActiveDepartments (dispatch, payload) {
				return dispatch(this.namespace + 'fetchActiveDepartments', payload)
			},
			fetchSubjects (dispatch, payload) {
				return dispatch(this.namespace + 'fetchSubjects', payload)
			},
			fetchTags (dispatch, payload) {
				return dispatch(this.namespace + 'fetchTags', payload)
			},
			fetchGeoData (dispatch, payload) {
				return dispatch(this.namespace + 'fetchGeoData', payload)
			},
			fetchAllCustomFields (dispatch, payload) {
				return dispatch(this.namespace + 'fetchAllCustomFields', payload)
			},
			filterDeliverables (dispatch, payload) {
				return dispatch(this.namespace + 'filterDeliverables', payload)
			},
			fetchViews (dispatch, payload) {
				return dispatch(this.namespace + 'fetchViews', payload)
			},
			fetchProjects (dispatch, payload) {
				return dispatch(this.namespace + 'fetchProjects', payload)
			},
			getDeliverableTypes (dispatch, payload) {
				return dispatch(this.namespace + 'getDeliverableTypes', payload)
			},
			fetchUserManageProjects (dispatch, payload) {
				return dispatch(this.namespace + 'fetchUserManageProjects', payload)
			},
			fetchDeliverableCount (dispatch, payload) {
				return dispatch(this.namespace + 'fetchDeliverableCount', payload)
			},
			updateSocialMediaPostUrl (dispatch, payload) {
				return dispatch(this.namespace + 'updateSocialMediaPostUrl', payload)
			},
		}),
		...mapMutations({
		  setDataLoading (commit, payload) {
		    return commit(this.namespace + 'setDataLoading', payload)
		  },
		  setOpenWithFocus (commit, payload) {
		    return commit(this.namespace + 'setOpenWithFocus', payload)
		  },
		}),

	getNoDateText(deliverables) {
			let x = 0;
			let noDateCount = 0;
			if (deliverables) {
				for(x = 0; x < deliverables.length;x++) {
					if (deliverables[x].publish_date == null) {
						if (!deliverables[x].is_master) {
							noDateCount++;
						}
					}
				}
			}
			if (noDateCount > 0) {
				if (noDateCount > 1) {
					return '<span class="not-set exclude-outside-click" v-else>No Date x ' + noDateCount + '</span>';
				} else {
					return '<span class="not-set exclude-outside-click" v-else>No Date</span>';
				}
			}

			return "";
		},


		toggleExpanded() {
			this.expanded = !this.expanded;
			this.$emit('toggleExpanded');
		},

		getRowClass(deliverable, index) {
			let classes = "row listing-row";
			// const isMaster = deliverable.is_master;
			// if (isMaster) {
			// 	classes += " is-master";
			// }
			if (deliverable) {
				if(deliverable.social_series){
					if (deliverable.social_series.length) {
						classes += " is-social-series";
					}
				} else {
					if(deliverable.social_campaigns){
						if (deliverable.social_campaigns.length) {
							classes += " is-social-campaign";
						}
					}
				}

				// Check to see if we need to put the separator between
				if (index > 0 && this.namespace == "") {
					const prevDeliverable = this.deliverablesArray[index - 1];
					if (prevDeliverable) {
						if (deliverable.publish_date == null && prevDeliverable.publish_date != null) {
							classes += " is-separate-date";
						}
					}
				}

				if(parseInt(deliverable.id) === parseInt(this.selectedDeliverable)){
					classes += " active";
				}
			}

			return classes;
		},

		getSocialNetworkColorClass(network, deliverable) {
			if (deliverable) {
				var has_caption = false;
				var has_missing = false;
				if (deliverable.social_posts) {
					for (var x =0; x < deliverable.social_posts.length; x++) {
							for (var xx =0; xx < deliverable.social_posts[x].social_networks.length; xx++) {
								if (network == deliverable.social_posts[x].social_networks[xx]) {
									var current_caption = false;
									if (deliverable.social_posts[x].caption != null && deliverable.social_posts[x].caption != "") {
										has_caption = true;
										current_caption = true;

									}
									if (!has_caption) {
										// let's see if there is a re-tweet share url.
										if (deliverable.social_posts[x].share_urls) {
											if (deliverable.social_posts[x].share_urls.length > 0) {
												for (var xx =0; xx < deliverable.social_posts[x].share_urls.length; xx++) {
													if (deliverable.social_posts[x].share_urls[xx].url != "" &&
													deliverable.social_posts[x].share_urls[xx].url != null
													&& deliverable.social_posts[x].share_urls[xx].network_id == network.id
													)  {
														has_caption = true;
														current_caption = true;

													}
												}
											}
										}
									}
									if (deliverable.social_posts[x].files) {
										if (deliverable.social_posts[x].files) {
											if (deliverable.social_posts[x].files.length > 0) {
												for (var xxx = 0; xxx < deliverable.social_posts[x].files.length; xxx++) {
													if (deliverable.social_posts[x].files[xxx].alt_text == null || deliverable.social_posts[x].files[xxx].alt_text == "") {
														has_missing = true;
													}
												}
											}
										}
									}
									if (!current_caption) {
										has_missing = true;
									}
								}
							}
					}
				}
				if (!has_missing) {
					return "has-content";
				} else {
					return "no-content"
				}
			}
		},

		getLangColorClass(lang_id,deliverable) {
			if (deliverable) {
				var has_caption = false;
				var has_missing = false;
				if (deliverable.social_posts) {
					for (var x =0; x < deliverable.social_posts.length; x++) {
						if (deliverable.social_posts[x].lang_id == lang_id) {
							var current_caption = false;
							if (deliverable.social_posts[x].caption != null && deliverable.social_posts[x].caption != "") {
								has_caption = true;
								current_caption = true;
							}
							if (!has_caption) {
								// let's see if there is a re-tweet share url.
								if (deliverable.social_posts[x].share_urls) {
									if (deliverable.social_posts[x].share_urls.length > 0) {
										for (var xx =0; xx < deliverable.social_posts[x].share_urls.length; xx++) {
											if (deliverable.social_posts[x].share_urls[xx].url != "" &&
											deliverable.social_posts[x].share_urls[xx].url != null
											)  {
												has_caption = true;
												current_caption = true;
											}
										}
									}
								}
							}
							if (!current_caption) {
								has_missing = true;
							}
							if (deliverable.social_posts[x].files) {
								if (deliverable.social_posts[x].files) {
									if (deliverable.social_posts[x].files.length > 0) {
										for (var xxx = 0; xxx < deliverable.social_posts[x].files.length; xxx++) {
											if (deliverable.social_posts[x].files[xxx].alt_text == null || deliverable.social_posts[x].files[xxx].alt_text == "") {
												has_missing = true;
											}
										}
									}
								}
							}

						}
					}
				}
				if (!has_missing) {
					return "has-content";
				} else {
					return "no-content"
				}
			}

		},

		getNewPostButtonText() {
			var btn = "New Calendar Post";
			if (this.socialSeriesId != null && this.socialCampaignId != null && this.hasSocialCampaign && this.hasSocialSeries) {
						btn = "New Campaign Series Post";
			}
			if (this.socialSeriesId != null && !this.hasSocialCampaign && this.hasSocialSeries) {
				btn = "New Series Post";
			}
			if (this.socialCampaignId != null && this.hasSocialCampaign && !this.hasSocialSeries) {
				btn = "New Campaign Post";
			}
			return btn;
		},


		getCalendarTypeText(deliverable) {
			let text = "";
			const campaign = this.allSocialCampaigns.find(x => x.id == deliverable.social_campaigns[0]);
			const series = this.allSocialSeries.find(x => x.id == deliverable.social_series[0]);

			if (campaign) {
				text += campaign.name;
			}
			if (series) {
				if (campaign) text += " > ";
				text += series.name;
			}

			if (text == "") return "Monthly Calendar";
			return text;
		},

		getDeliverablePageTitle() {
			let returnData = '';
			let totalOutletCount = this.outletCount ? this.outletCount : 0;
			let totalDeliverableCount = this.allDeliverablesPaginationData.total ? this.allDeliverablesPaginationData.total : 0;
			if(typeof this.deliverableFilter.deliverableType == 'undefined') {
				return 'Deliverables'  + '<span class="text-muted">('+totalDeliverableCount+' deliverables, '+totalOutletCount+' calls)</span>'
			}
			if((typeof this.deliverableFilter.deliverableType.name != 'undefined' && typeof(this.deliverableFilter.deliverableType[0]) == 'undefined') && this.deliverableFilter.deliverableType.name != 'All') {
				returnData = this.deliverableFilter.deliverableType.name;
			} else {
				returnData = 'Deliverables';
			}
			return returnData + '<span class="text-muted">('+totalDeliverableCount+' deliverables, '+totalOutletCount+' calls)</span>';
		},
		deliverableTypeTitle(deliverableTypeId) {
			if(this.deliverableTypes) {
				let typeData = _.filter(this.deliverableTypes, {typeId: deliverableTypeId});
				if(typeData.length > 0) {
					return typeData[0].name;
				}
			}
		},
		handleResetFilter() {
			$('.viewmenu-dropdown').removeClass('show');
			this.$root.$emit(this.namespace+'resetFilter')
		},
		updatePerfectScroll() {
			let self = this;
			setTimeout(function() {
				if(typeof self.$refs.views__scroll != 'undefined') {
					self.$refs.views__scroll.update();
				}
			}, 1);
		},
		setActiveView() {
			if(this.$router.currentRoute.name == 'dashboard') {
				if(localStorage.getItem('dashboardActiveSave')) {
					this.activeView = localStorage.getItem('dashboardActiveSave');
					this.viewBtnLabel = localStorage.getItem('dashboardActiveSaveTitle');
					this.currentViewData = localStorage.getItem('dashboardActiveSaveData');
					if (!this.activeView.startsWith('p')) this.showUpdateView = true;
				} else {
					this.activeView =  '-1';
					this.viewBtnLabel = 'Views';
					this.showUpdateViewText = false;
				}
			} else if(this.$router.currentRoute.name == 'myWeek') {
				if(localStorage.getItem('myWeekActiveSave')) {
					this.activeView = localStorage.getItem('myWeekActiveSave');
					this.viewBtnLabel = localStorage.getItem('myWeekActiveSaveTitle');
					this.currentViewData = localStorage.getItem('myWeekActiveSaveData');
					if (!this.activeView.startsWith('p')) this.showUpdateView = true;
				} else {
					this.activeView =  '-1';
					this.viewBtnLabel = 'Views';
					this.showUpdateViewText = false;
				}
			} else if(this.$router.currentRoute.name == 'mediaCallPage') {
				if(localStorage.getItem('mediaCallActiveSave')) {
					this.activeView = localStorage.getItem('mediaCallActiveSave');
					this.viewBtnLabel = localStorage.getItem('mediaCallActiveSaveTitle');
					this.currentViewData = localStorage.getItem('mediaCallActiveSaveData');
					if (!this.activeView.startsWith('p')) this.showUpdateView = true;
				} else {
					this.activeView =  '-1';
					this.viewBtnLabel = 'Views';
					this.showUpdateViewText = false;
				}
			}

			this.showNewViewTitleArea = false;
			this.showUpdateViewTitleArea = false;
		},
		removeView(viewId) {
			if(this.$router.currentRoute.name == 'dashboard') {
				if(viewId == localStorage.getItem('dashboardActiveSave')) {
					this.resetView();
				}
			} else if(this.$router.currentRoute.name == 'myWeek') {
				if(viewId == localStorage.getItem('myWeekActiveSave')) {
					this.resetView();
				}
			} else if(this.$router.currentRoute.name == 'mediaCallPage') {
				if(viewId == localStorage.getItem('mediaCallActiveSave')) {
					this.resetView();
				}
			}
			this.$store.dispatch(this.namespace + 'removeView', viewId);
		},
		resetView() {
			localStorage.removeItem("dashboardActiveSave");
			localStorage.removeItem("myWeekActiveSave");
			localStorage.removeItem("dashboardActiveSaveTitle");
			localStorage.removeItem("myWeekActiveSaveTitle");
			localStorage.removeItem("mediaCallActiveSave");
			localStorage.removeItem("mediaCallActiveSaveTitle");
			this.setActiveView();
		},
		loadView(viewData) {
			this.currentViewData = JSON.parse(viewData.saved_data);
			let index = viewData.id;
			this.showUpdateView = true;
			this.viewBtnLabel = viewData.title;
			if(this.$router.currentRoute.name == 'dashboard') {
				this.activeView = index;
				localStorage.setItem('dashboardActiveSave', index);
				localStorage.setItem('dashboardActiveSaveTitle', viewData.title);
				localStorage.setItem('dashboardActiveSaveData', viewData.saved_data);
			} else if(this.$router.currentRoute.name == 'myWeek') {
				this.activeView = index;
				localStorage.setItem('myWeekActiveSave', index);
				localStorage.setItem('myWeekActiveSaveTitle', viewData.title);
				localStorage.setItem('myWeekActiveSaveData', viewData.saved_data);
			} else if(this.$router.currentRoute.name == 'mediaCallPage') {
				this.activeView = index;
				localStorage.setItem('mediaCallActiveSave', index);
				localStorage.setItem('mediaCallActiveSaveTitle', viewData.title);
				localStorage.setItem('mediaCallActiveSaveData', viewData.saved_data);
			}
			if(this.$router.currentRoute.name == 'dashboard') {
				this.$store.commit(this.namespace + 'setDashboardDeliverableFilter', viewData.saved_data);
				this.$root.$emit(this.namespace+'setSaveView', this.deliverableFilter);
				// this.filterQuery = this.deliverableFilter;
			} else if(this.$router.currentRoute.name == 'myWeek') {
				this.$store.commit(this.namespace + 'setMyWeekDeliverableFilter', viewData.saved_data);
				this.$root.$emit(this.namespace+'setSaveView', this.myWeekDeliverableFilter);
				// this.filterQuery = this.myWeekDeliverableFilter;
			} else if(this.$router.currentRoute.name == 'mediaCallPage') {
				this.$store.commit(this.namespace + 'setMediaCallFilter', viewData.saved_data);
				this.$root.$emit(this.namespace+'setSaveView', this.mediaCallFilter);
				// this.filterQuery = this.myWeekDeliverableFilter;
			}
		},
		loadViewFromModal(viewData) {
			this.loadView(viewData);
			this.$bvModal.hide("headerViewSelectModal");
		},
		saveView() {
			this.$bvModal.show("viewTitleModal");
		},
		modalSaveView() {
			this.showNewViewTitleArea = true;
		},
		directUpdateView() {
			this.showUpdateViewText = false;
			let view = "";
			if (this.$router.currentRoute.name == "dashboard") {
				view = this.deliverableFilter;
			} else if (this.$router.currentRoute.name == "myWeek") {
				view = this.myWeekDeliverableFilter;
			} else if (this.$router.currentRoute.name == "mediaCallPage") {
				view = this.mediaCallFilter;
			}
			let viewData = {
					title: this.viewBtnLabel,
					filterQuery: view,
					viewId: this.activeView
				};
			let that = this;
			this.$store.dispatch(this.namespace + "saveView", viewData).then(function() {
				if(that.$router.currentRoute.name == 'dashboard') {
					localStorage.setItem('dashboardActiveSaveData', JSON.stringify(view));
				} else if(that.$router.currentRoute.name == 'myWeek') {
					localStorage.setItem('myWeekActiveSaveData', JSON.stringify(view));
				} else if(that.$router.currentRoute.name == 'mediaCallPage') {
					localStorage.setItem('mediaCallActiveSaveData', JSON.stringify(view));
				}
				that.setActiveView();
				toast.info('View has been saved.');
			});
		},
		updateView() {
			this.$bvModal.show("viewTitleUpdateModal");
		},
		modalUpdateView() {
			this.showUpdateViewTitleArea = true;
		},
		viewSelectModalHidden() {
			this.showNewViewTitleArea = false;
			this.showUpdateViewTitleArea = false;
		},
		setPriority(deliverable, isMobile) {
			let priority;
			if (isMobile) {
				priority = $('.mobile-deli-info .listing-priority-del-'+deliverable.id+' .vue-star-rate ul.list li.active').length;
			} else {
				priority = $('.data-items.hide-mobile .listing-priority-del-'+deliverable.id+' .vue-star-rate ul.list li.active').length;
			}
			let priorityData = {
				field_id: 23,
				parentId: null,
				value: priority,
				deliverable_id: deliverable.id,
				id: deliverable.id
			};
			this.updateFieldValue(priorityData);
		},
		editSocialModalHidden() {
			this.$store.commit(this.namespace + 'setDeliverable', this.deliverableDetail)
		},
		hasMyWeek() {
			if (this.userDeliverables) {
				if (this.userDeliverables.overdue.length > 0 ||
				this.userDeliverables.today.length > 0 ||
				this.userDeliverables.thisWeek.length > 0 ||
				this.userDeliverables.nextWeek.length > 0 ||
				this.userDeliverables.upcoming.length > 0 ||
				this.userDeliverables.noDeadline.length > 0
				// || this.userDeliverables.completed.length > 0
				) {
					return true;
				}
			}
			return false;
		}
		,
		createNewDeliverable() {
			// Hard coded
			let type = 'social_media';
			this.$store
			.dispatch("createNewDeliverable", { type })
			.then(() => {
				let currentTitle = document.title.match(/\(\d+\)\s/g);
				if(!currentTitle) {
					document.title = this.deliverableDetail.title;
				} else {
					document.title = currentTitle[0] + this.deliverableDetail.title;
				}
				if (this.namespace == "relatedDeliverables/") {
					this.$bvModal.show('editRelatedSocialModal');
				} else {
					this.$bvModal.show('editSocialModal');
				}
				this.$nextTick(() => {
					$('.edit-social-deliverable-modal .deliverable-title').trigger('click');
				})
				// this.$store.dispatch(this.namespace + "fetchDeliverables")
				this.$store.dispatch(this.namespace + "fetchSocialMediaDeliverablesGrouped", this.socialMediaFilterParams)
				this.fetchDeliverableCount();
			});
		},
		focusContactModal() {
			this.$refs.refContactModal.focusMyElement();
		},
		focusUpdateContactModal() {
			this.$refs.refUpdateContactModal.focusMyElement();
		},
		focusSpokespersonModal() {
			this.$refs.refSpokespersonModal.focusMyElement();
		},
		focusUpdateSpokespersonModal() {
			this.$refs.refUpdateSpokespersonModal.focusMyElement();
		},
		focusWhoModal() {
			this.$refs.refWhoModal.focusMyElement();
		},
		focusUpdateWhoModal() {
			this.$refs.refUpdateWhoModal.focusMyElement();
		},
		onChangePage(data) {
			this.setDataLoading(true);
			this.socialMediaFilterParams.page = data;
			this.socialMediaFilterParams.pageCount = this.pageCount;
			this.$root.$emit(this.namespace+'socialMediaFilterQueryUpdate', {
			  filterParams: this.socialMediaFilterParams,
			  namespace: this.namespace,
			  filterParams: {
    	  	page:data
    	  },
			});
		},

		getSeriesMasterByDeliverable(deliverable){
      let series = deliverable.social_series_deliverables;
      if(series.length){
        let master = series.find(x => x.is_master === 1);
        if(master){
          return master.id;
        }
      }
      return false;
    },

		showModalFn(deliverable) {
			/*
			if(deliverable.social_series.length && !deliverable.manually_updated_at){
				this.$emit("showEditDeliverableModal", this.getSeriesMasterByDeliverable(deliverable));
			} else {
				this.$emit("showEditDeliverableModal", deliverable);
			}
			*/
			this.$emit("showEditDeliverableModal", deliverable);
		},

		clickDeliverableTitle(deliverable, event){
			this.lastFocusTarget = event.target;
			this.$emit("showEditDeliverableModal", deliverable, 0);
		},
		clickPostCopy(deliverable, event){
			if(event.target.tagName != "A") {
				this.lastFocusTarget = event.target;
				const selectedLangInListing = this.systemSettings.languages.filter(x => x.id === this.showPostContentLangInListing);
				const langCode = selectedLangInListing[0].lang_code ? selectedLangInListing[0].lang_code : "en";

				const selectedSmPlatformInListing = this.systemSettings.social_networks.filter(x => x.id === this.showPostContentNetworkInListing);
				const smPlatformSlug = this.getSocialNetworkClass(selectedSmPlatformInListing[0].api_type);

				this.setOpenWithFocus(`.language-${langCode} .platform-${smPlatformSlug} .post-caption`);
				this.$emit("showEditDeliverableModal", deliverable, 0);
			}
		},
		clickPlatforms(deliverable, event){
			this.lastFocusTarget = event.target;
			this.$emit("showEditDeliverableModal", deliverable, 0);
		},
		clickLanguages(deliverable, event){
			this.lastFocusTarget = event.target;
			this.$emit("showEditDeliverableModal", deliverable, 0);
		},


		clickThumbnail(deliverable, event){
			this.lastFocusTarget = event.target;
			this.$emit("showEditDeliverableModal", deliverable, 0);
		},
		clickThumbnailAltText(deliverable, event){
			this.lastFocusTarget = event.target;
			this.$emit("showEditDeliverableModal", deliverable, 0);
		},
		clickTaskUsers(deliverable, event){
				this.lastFocusTarget = event.target;
				this.setOpenWithFocus(".below-tasks");
				this.$emit("showEditDeliverableModal", deliverable, 0);
		},



		clickDeliverableCommentsCell(deliverable, event){
			this.lastFocusTarget = event.target;
			this.setOpenWithFocus(".nav-item.tabCommentsTitle");
			this.$emit("showEditDeliverableModal", deliverable, 1);
		},

		clickDeliverableComments(deliverable){
			this.setOpenWithFocus(".nav-item.tabCommentsTitle");
			this.$emit("showEditDeliverableModal", deliverable, 1);
		},

		clickDeliverableStatus(deliverable, event){
			this.$emit("showEditDeliverableModal", deliverable, 2);
		},

		removeRoute() {
			if(this.$router.currentRoute.path.indexOf('social-media/') != -1) {
				this.$router.push({name: 'socialMedia'});
			} else {
				history.pushState(
					{},
					null,
					this.$router.currentRoute.path
				);
			}
		},

		getPublishStatus(deliverable) {
			var html = "";
			if (deliverable.publish_status) {
				var status = JSON.parse(deliverable.publish_status);
				if (status.slug == "cancelled") {
					html += "<span class='publish-status-notes'>ICON</span>";
				}
				html += "<span class='publish-status "+status.slug + "' style='background-color:"+status.color+"'>"+status.name+"</span>";
			}
			return html;
		},





		getPublishStatusStyle(publish_status) {
			if (publish_status) {
				var status = JSON.parse(publish_status);
				// return "background-color:"+status.color + "; color:#fff";
				return "background-color:"+status.color+"";
			}
		},

		getPublishStatusClass(publish_status){
			let cl = "value-set exclude-outside-click";
			if (publish_status) {
				var status = JSON.parse(publish_status);
					cl += " "+status.slug;
			}
			return cl;
		},

		getPublishDateStyle(publish_date){
			if (publish_date) {

				let localPublishDate = this.$moment.utc(publish_date).local();
				let now = this.$moment.utc().local();
				if (localPublishDate.isSame(now, 'day')) {
					return "font-weight:bold; width:100%; display:block;"
				}
				if (localPublishDate.isBefore(now)) {
					// return "color:#999 !important; background:#eeee!important; width:100%; display:block;";
				}

			}
		},


		getPublishStatusText(publish_status) {
			if (publish_status) {
				var status = JSON.parse(publish_status);
				return status.name;
			}
		},

		getSocialPostThumbnailAndAltText(deliverable) {
			let html = this.getSocialPostThumbnail(deliverable);
			if (html != "") {
				html += this.getSocialPostAltText(deliverable);
			}
			return html;
		},

		getSocialPostThumbnail(deliverable) {
			var html = "";
			if (deliverable) {

				let that = this;
				let posts = deliverable.social_posts.filter(function(post){
					if(post.lang_id === that.showPostContentLangInListing ){
						return true;
					}
				});
				if(posts.length){
					let x = 0;
					for (x = 0; x < posts.length; x++) {
						if (posts[x].files && posts[x].social_networks.includes(that.showPostContentNetworkInListing)) {

							if (posts[x].files) {
								let placeholderFilename = process.env.MIX_APP_URL + "images/sm-calendar-placeholder.svg";
								if (posts[x].files.length > 0) {
									html += `<img 
										src="${this.apiUrl}viewFileSocialMediaPostResized/thumbnail/${posts[x].id}/${posts[x].files[0].id}/${this.token}"
										alt="${posts[x].files[0].alt_text}"
										onerror="this.onerror=null; this.src='${placeholderFilename}'"
										/>`;
									/*
									for(var  x = 0; x < deliverable.social_posts[0].files.length; x++) {
										html += "<img src='"+this.apiUrl+"viewFileSocialMediaPost/"+deliverable.social_posts[0].id+"/"+deliverable.social_posts[0].files[x].id+"/"+this.token+"'/>";
									}
									*/
								}
							}

						}
					}
				}
			}
			return html;
		},
		getSocialPostCaption(deliverable, returnCount = false) {
			if (deliverable) {
				if (deliverable.social_posts) {
					if (deliverable.social_posts[0]) {
						if(deliverable.social_posts[0].caption){
							let caption = deliverable.social_posts[0].caption;
							if(returnCount){
								//return "("+caption.length+" characters)";
								return caption.length;
							}
							if(caption.length > this.captionMaxLength){
								caption = caption.substr(0, this.captionMaxLength);
								caption = caption.substr(0, caption.lastIndexOf(" ")) + "...";
							}
							return caption;
						}
					}
				}
			}
		},
		getSocialPostAltText(deliverable) {
			var html = "";
			if (deliverable) {

				let that = this;
				let posts = deliverable.social_posts.filter(function(post){
					if(post.lang_id === that.showPostContentLangInListing ){
						return true;
					}
				});
				if(posts.length){
					let x = 0;
					for (x = 0; x < posts.length; x++) {
						if (posts[x].files && posts[x].social_networks.includes(that.showPostContentNetworkInListing)) {
							if (posts[x].files) {
								if (posts[x].files.length > 0) {
									if (posts[x].files[0].alt_text != null) {
										html += posts[x].files[0].alt_text;
									}
								}
							}

						}
					}
				}
			}
			if (html == "") {
					html += "<span class='not-set'>No Alt Text</span>";
			} else {
				html = "<span class='has-content'>"+html+"</span>";
			}
			return html;
		},

		getCaption(deliverable,returnCount = false){
			let that = this;
			let posts = deliverable.social_posts.filter(function(post){
				if(post.lang_id === that.showPostContentLangInListing ){
					return true;
				}
			});
			if(posts.length){
				let x = 0;
				for (x = 0; x < posts.length; x++) {
					if (posts[x].caption && posts[x].social_networks.includes(that.showPostContentNetworkInListing)) {
						let caption = posts[x].caption;
						if(returnCount){
							return caption.length;
						}
						if(caption.length > this.captionMaxLength){
							caption = caption.substr(0, this.captionMaxLength);
							caption = caption.substr(0, caption.lastIndexOf(" ")) + "...";
						}
						return Autolinker.link(caption);
					}
				}
			}
			if(returnCount){
				return 0;
			}
			return "";
		},



		getFirstSocialPostThumbnail(deliverable) {
			var html = "";
			if (deliverable) {
				if (deliverable.social_posts) {
					if (deliverable.social_posts[0]) {
						if (deliverable.social_posts[0].files) {
							if (deliverable.social_posts[0].files.length > 0) {
									html += "<img src='"+this.apiUrl+"viewFileSocialMediaPost/"+deliverable.social_posts[0].id+"/"+deliverable.social_posts[0].files[0].id+"/"+this.token+"'/>";
								/*
								for(var  x = 0; x < deliverable.social_posts[0].files.length; x++) {
									html += "<img src='"+this.apiUrl+"viewFileSocialMediaPost/"+deliverable.social_posts[0].id+"/"+deliverable.social_posts[0].files[x].id+"/"+this.token+"'/>";
								}
								*/
							}
						}
					}
				}
			}
			return html;
		},
		getFirstSocialPostCaption(deliverable, returnCount = false) {
			if (deliverable) {
				if (deliverable.social_posts) {
					if (deliverable.social_posts[0]) {
						if(deliverable.social_posts[0].caption){
							let caption = deliverable.social_posts[0].caption;
							if(returnCount){
								//return "("+caption.length+" characters)";
								return caption.length;
							}
							if(caption.length > this.captionMaxLength){
								caption = caption.substr(0, this.captionMaxLength);
								caption = caption.substr(0, caption.lastIndexOf(" ")) + "...";
							}
							return caption;
						}
					}
				}
			}
		},
		getFirstSocialPostAltText(deliverable) {
			var html = "";
			if (deliverable) {
				if (deliverable.social_posts) {
					if (deliverable.social_posts[0]) {
						if (deliverable.social_posts[0].files) {
							if (deliverable.social_posts[0].files.length > 0) {
								if (deliverable.social_posts[0].files[0].alt_text != null) {
									html += deliverable.social_posts[0].files[0].alt_text;
								}
							}
						}
					}
				}
			}
			return html;
		},
		getCaptionForLang(deliverable, lang, returnCount = false){
			let posts = deliverable.social_posts.filter(function(post){
				if(post.lang_id === lang.id && post.is_primary){
					return true;
				}
			});
			if(posts.length){
				let caption = posts[0].caption;
				if(caption){
					if(returnCount){
						return caption.length;
					}
					if(caption.length > this.captionMaxLength){
						caption = caption.substr(0, this.captionMaxLength);
						caption = caption.substr(0, caption.lastIndexOf(" ")) + "...";
					}
					return Autolinker.link(caption);
				}
			}
			if(returnCount){
				return 0;
			}
			return "";
		},

		formatDate(theDate) {
			let html = "";

			if (theDate == null) {
				html = "<span class='not-set'>Not set</span>";
			} else {
				let localDate = this.$moment.utc(theDate).local();
				if (this.currentYear == localDate.format("YYYY")) {
					if (this.currentMonth == localDate.format("MM") && this.currentDay == localDate.format("DD")) {
							html = "Today " + localDate.format(" @ h:mm a");
					} else {
						html = localDate.format("ddd, MMM D @ h:mm a");
					}


				} else {
					html = this.$moment.utc(theDate).local().format("ddd, MMM D YYYY @ h:mm a");
				}
			}
			return html;
		},

		infoColStyle(deliverable) {
			// Unused for now
            const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(deliverable.deliverable_template_id));
			if (deliverableTemplateSlug == "project-deliverable") {
				// return 'min-height:96px';
				return '';
			} else {
				return null;
			}
		},

		userCanEditDeliverable() {
            return (this.userAbilities.deleteMediaCall);
        },

		deleteDeliverableClick(deliverable) {
			this.$emit('deleteSocialMediaDeliverable', deliverable);
		},
		deleteDeliverableClickOutside(deliId) {
			let that = this;
			return () => {
				if (that.stripRemoveDeliverableId == deliId) {
					that.stripRemoveDeliverableId = null;
				}
			}
		},

		deleteDeliverable(deliverable) {
			this.$emit('deleteDeliverable', deliverable);
		},

    duplicateDeliverable(deliverable) {
			this.$emit('duplicateDeliverable', deliverable);
   },

		duplicateDeliverableClickOutside(deliId) {
			let that = this;
			return () => {
				if (that.stripRemoveDeliverableId == deliId) {
					that.stripRemoveDeliverableId = null;
				}
			}
		},


		onConfirmRemoveDeliverable() {

			if (this.showRemoveDeliverableId) {
				let that = this;
				let deliverable = null;
				if (this.deliverablesArray instanceof Array) {
					deliverable = this.deliverablesArray.find(x => x.id == this.showRemoveDeliverableId);
				} else {
					for (let i of Object.keys(this.deliverablesArray)) {
						deliverable = this.deliverablesArray[i].find(x => x.id == this.showRemoveDeliverableId);
						if (deliverable != null) break;
					}
				}
				this.$store.dispatch(this.namespace + "removeDeliverable", { deliverableId:this.showRemoveDeliverableId }).then(function() {
					that.$bvModal.hide("deleteDeliverableConfirmModal");
					// TODO: removing a deliverable should only remove it from the list, not replace entire list.
					// that.$store.commit(this.namespace + 'removeMediaCallFromList', deliverableId);
					// that.$store.dispatch(that.namespace + 'countOutlets');

					that.showRemoveDeliverableId = null;

					that.$store.dispatch(that.namespace + 'fetchSocialMediaDeliverablesGrouped', this.socialMediaFilterParams).then(function() {
						toast.hide();

							that.$store.dispatch(that.namespace + 'manageUndoActivation', 'Deliverable deleted.');

						that.$store.dispatch(that.namespace + 'fetchProjectDeliverable');
					});
				});
			}
		},
		onCancelRemoveDeliverable() {
			this.showRemoveDeliverableId = null;
		},

		changeDeliverableType(deliverable, type) {
			if (deliverable.deliverable_template_id == type.typeId) return;
			this.$store.dispatch(this.namespace + 'changeDeliverableType', {
				id: deliverable.id,
				deliverable_type: type.id,
			}).then(r => {
				this.$store.dispatch(this.namespace + 'manageUndoActivation', 'Deliverable type changed.');
			});
		},

		showManuallyUpdatedIcon(deliverable){
			if(deliverable.manually_updated_at){
				return true;
			}
			return false;
		},

		getDeliverableSideBarStyle(deliverable) {
			if (deliverable.publish_status) {
				const publishStatus = JSON.parse(deliverable.publish_status);
				return {backgroundColor: publishStatus.color};
			}
		},
		async newPost() {
		    const currentScroll = window.scrollY;
		    this.setDataLoading(true);
		    const type = {id: 'social_media', name: 'Social Media'};

		    await this.createNewDeliverable({ type: type.id, social_campaign_id: this.socialCampaignId, social_series_id : this.socialSeriesId });
		    if (type.id == 'social_media') {
		        if (this.groupTypeTitle == 'Campaign') {
		            await this.setDeliverableSocialCampaign({
		                id: this.deliverableDetail.id,
		                social_campaign_id: this.campaignId
		            });
		        } else if (this.groupTypeTitle == 'Series') {
		            await this.setDeliverableSocialSeries({
		                id: this.deliverableDetail.id,
		                social_series_id: this.seriesId
		            });
		        } else if (this.groupTypeTitle == 'Campaign Series') {
		        	await this.setDeliverableSocialCampaign({
		        	    id: this.deliverableDetail.id,
		        	    social_campaign_id: this.campaignId
		        	});
		            await this.setDeliverableSocialSeries({
		                id: this.deliverableDetail.id,
		                social_series_id: this.seriesId
		            });
		        }

		        this.setDataLoading(false);
				if (this.namespace == "relatedDeliverables/") {
					this.setDataLoading(true);
					this.$bvModal.show('editRelatedSocialModal');
					this.$store.dispatch(this.namespace + "fetchSocialMediaDeliverablesGrouped", { filter: this.filterQuery }).then(() => {
						this.setDataLoading(false);
					});
				} else {
					this.$bvModal.show('editSocialModal');
		        await this.fetchSocialMediaDeliverablesGrouped(this.socialMediaFilterParams);
				}
		        window.scrollTo(0, currentScroll);
		    }
		},

		onShowUpdateViewText(payload) {
			let that = this;

			if(that.$router.currentRoute.name != 'myWeek' && that.$router.currentRoute.name != 'dashboard' && that.$router.currentRoute.name != 'mediaCallPage') return;

			let currentFilter = payload.currentFilter
			let excludedKeys = ['myWeek'];
			let tempJson1 = currentFilter;

			if(!payload.isFilterActive) {
				that.activeView = '-1'
				that.viewBtnLabel = 'Views'
			}

			let tempJson2 = that.activeView != '-1' ? that.currentViewData : false;
			if(typeof tempJson2 == 'string') {
				tempJson2 = JSON.parse(that.currentViewData);
			}

			that.showUpdateViewText = false;
			if(tempJson2) {
				Object.entries(currentFilter).forEach(([key, value]) => {
					if(typeof tempJson2[key] != 'undefined'
						&& excludedKeys.indexOf(key) == -1) {
						if(key == 'dateRange' || key == 'dateCreatedRange' || key == 'dateCompletedRange') {
							let tempDateFlags = {
								dateRange: 'filterByDate',
								dateCreatedRange: 'filterByDateCreated',
								dateCompletedRange: 'filterByDateCompleted'
							};
							if(tempJson2[tempDateFlags[key]]) {
								let temp1StartDate = (typeof tempJson1[key].startDate != 'string') ? tempJson1[key].startDate.toISOString() : tempJson1[key].startDate,
									temp1EndDate = (typeof tempJson1[key].endDate != 'string') ? tempJson1[key].endDate.toISOString() : tempJson1[key].endDate,
									temp2StartDate = (typeof tempJson2[key].startDate != 'string') ? tempJson2[key].startDate.toISOString() : tempJson2[key].startDate,
									temp2EndDate = (typeof tempJson2[key].endDate != 'string') ? tempJson2[key].endDate.toISOString() : tempJson2[key].endDate;
								if((temp1StartDate.substr(0, 10) != temp2StartDate.substr(0, 10)) && temp1EndDate.substr(0, 10) != temp2EndDate.substr(0, 10)) {
									if (((typeof that.activeView).toLowerCase() == "string" && that.activeView.startsWith('p')) || that.activeView == -1) {
										that.activeView = -1;
									} else {
										that.showUpdateViewText = true;
									}
									return;
								}
							}
						} else {
							if(JSON.stringify(tempJson1[key]) != JSON.stringify(tempJson2[key])) {
								if (((typeof that.activeView).toLowerCase() == "string" && that.activeView.startsWith('p')) || that.activeView == -1) {
									that.activeView = -1;
								} else {
									that.showUpdateViewText = true;
								}
								return;
							}
						}
					}
				});
			}

		},

		onBvModalShow(bvEvent, modalId) {
			if (modalId == "editSocialModal") {
				this.editDeliverableModal = true;
			}

		},
		onBvModalHide(bvEvent, modalId) {
			if(modalId == 'editDeliverableModal' && this.$router.currentRoute.name == 'myWeek') {
				this.sortTasks({sortKey: false, deliverables: this.deliverablesArray, sortFields: true, namespace:this.namespace})
			}
			if (modalId == "editSocialModal") {
				let currentTitle = document.title.match(/\(\d+\)\s/g);
				if(!currentTitle) {
					document.title = process.env.MIX_APP_NAME;
				} else {
					document.title = currentTitle[0] + process.env.MIX_APP_NAME;
				}
			}
		},
		onUpdateListTitle(title) {
			this.listTitle = title;
		},

		onHideUpdateText() {
			this.showUpdateViewText = false;
		},
		onResetView() {
			this.resetView();
		},


		  enableCellNavigation() {
		    var arrow = {
		      left: 37,
		      up: 38,
		      right: 39,
		      down: 40
		    };

		    // select all on focus
		    // works for input elements, and will put focus into
		    // adjacent input or textarea. once in a textarea,
		    // however, it will not attempt to break out because
		    // that just seems too messy imho.
		    this.find('.dtd').keydown(function (e) {

		      // shortcut for key other than arrow keys
		      if ($.inArray(e.which, [arrow.left, arrow.up, arrow.right, arrow.down]) < 0) {
		        return;
		      }

		      var input = e.target;
		      var td = $(e.target).closest('td');
		      var moveTo = null;

		      switch (e.which) {

		        case arrow.left:
		          {
		            if (input.selectionStart == 0) {
		              moveTo = td.prev('td:has(input,textarea)');
		            }
		            break;
		          }
		        case arrow.right:
		          {
		            if (input.selectionEnd == input.value.length) {
		              moveTo = td.next('td:has(input,textarea)');
		            }
		            break;
		          }

		        case arrow.up:
		        case arrow.down:
		          {

		            var tr = td.closest('tr');
		            var pos = td[0].cellIndex;

		            var moveToRow = null;
		            if (e.which == arrow.down) {
		              moveToRow = tr.next('tr');
		            } else if (e.which == arrow.up) {
		              moveToRow = tr.prev('tr');
		            }

		            if (moveToRow.length) {
		              moveTo = $(moveToRow[0].cells[pos]);
		            }

		            break;
		          }

		      }

		      if (moveTo && moveTo.length) {

 						e.stopPropagation();
		        moveTo.find('input,textarea').each(function (i, input) {
		          input.focus();
		          input.select();
		        });

		      }

		    });

		  },


		  onBVModalEnablePointerEvents() {
		  		if (this.lastFocusTarget != null) {
		  				this.lastFocusTarget.style.focusVisible = "border:2px solid #000";
		  				this.lastFocusTarget.focus();
		  				this.lastFocusTarget = null;
		  		}

		  },

	},
	mounted() {
		let that = this;
		that.setDataLoading(true);

		// is this irrelevant?
		this.$root.$on('bv::modal::hide', this.onBvModalHide);
		this.$root.$on('updateListTitle', this.onUpdateListTitle);
		this.$root.$on('bv::modal::enable-pointer-events', this.onBVModalEnablePointerEvents);


		this.setActiveView();

		this.currentYear = this.$moment().format("YYYY");
		this.currentMonth = this.$moment().format("MM");
		this.currentDay = this.$moment().format("DD");


		this.$root.$on('hideUpdateText', this.onHideUpdateText);
		this.$root.$on(this.namespace+'resetView', this.onResetView);
		let tempJson3 = false;
		this.$root.$on(this.namespace+'showUpdateViewText', this.onShowUpdateViewText);

		Echo.channel('deliverable').listen('DeliverableUpdated', (e) => {
			let userId = localStorage.getItem("userId");
			if (userId != e.user.id) {
				let x = 0;
				for (x = 0; x < this.allDeliverables.length; x++) {
					if (this.allDeliverables[x].id == e.deliverable.deliverableId) {
						this.$store.commit(this.namespace + "setDeliverable", e.deliverable);
						this.$store.commit(this.namespace + "setDeliverableDetail", e.deliverable);
					}
				}
			}
		});

		Echo.channel('task').listen('TaskUpdated', (e) => {
			let userId = localStorage.getItem("userId");
			if (userId != e.user.id) {
				let x = 0;
				let xx = 0;
				for (x = 0; x < this.allDeliverables.length; x++) {

					if (this.allDeliverables[x].id == e.deliverableId) {
						// ok, lets update the task now for that deliverable..
						for (xx = 0; xx < this.allDeliverables[x].tasks.length; xx++) {
							if (this.allDeliverables[x].tasks[xx].taskId == e.task.taskId) {
								this.$store.commit(this.namespace + "setTask", {task:e.task, deliverableId: e.deliverableId});
								}
						}
					}
				}
			}
		});

		this.$root.$on("bv::modal::show", this.onBvModalShow);
		/*
		if(this.$router.currentRoute.path.indexOf('/social-media-grouped/') != -1  ) {
			let deliverableId = this.$router.currentRoute.path.split('/')[2],
				that = this;
			this.$store.dispatch(this.namespace + 'fetchSystemSettings').then(function(){
				that.$store.dispatch(that.namespace + 'getDeliverableDetail', {deliverableId: deliverableId}).then(function() {
					that.$bvModal.show('editSocialModal');
				});
			});
		}
		*/
	},
	destroyed() {
		this.$root.$off('bv::modal::hide', this.onBvModalHide);
		this.$root.$off('updateListTitle', this.onUpdateListTitle);
		this.$root.$off('hideUpdateText', this.onHideUpdateText);
		this.$root.$off(this.namespace+'resetView', this.onResetView);
		this.$root.$off(this.namespace+'showUpdateViewText', this.onShowUpdateViewText);
		this.$root.$off("bv::modal::show", this.onBvModalShow);
		this.$root.$off('bv::modal::enable-pointer-events', this.onBVModalEnablePointerEvents);

	},
	watch: {
		'$route': function(to, from) {
			if(to.path.indexOf('social-media/') != -1) {
				let deliverableId = to.path.split('/')[2],
					that = this;
				this.$store.dispatch(this.namespace + 'getDeliverableDetail', {deliverableId: deliverableId}).then(function() {
					that.$bvModal.show('editSocialModal');
				});
			}
		},
		'viewBtnLabel': function(oldVal, newVal) {
		},
	}
};
</script>
